import Vue from 'vue'
import auth0, { WebAuth, Auth0Callback, Auth0Result, Auth0UserProfile } from 'auth0-js'

let instance: Vue

/** Returns the current instance of the SDK */
export const getInstance = () => instance

/** Creates an instance of the Auth0 SDK. If one has already been created, it returns that instance */
export const useAuth0 = ({
  ...options
}: any) => {
  if (instance) return instance

  instance = new Vue({
    data(): Record<string, any> {
      return {
        auth0Client: null || WebAuth
      }
    },
    methods: {
      login(username: string, password: string) {
        // Auth0 email-password method
        return new Promise((resolve, reject) => {
          this.auth0Client.client.login({
            responseType: 'token',
            realm: 'Username-Password-Authentication',
            username: username,
            password: password
          }, (error: Auth0Callback<any>, authResult: Auth0Callback<any>) => {
            if (error) {
              reject(error)
            }

            if (authResult) {
              resolve(authResult)
            }
          })
        })
      },
      socialLogin(provider: string) {
        // Auth0 Client Social Login method
        return new Promise((resolve) => {
          this.auth0Client.popup.authorize({
            domain: options.domain,
            redirectUri: window.location.origin + '/login',
            connection: provider,
            responseType: 'token'
          }, (result: Auth0Callback<Auth0Result>) => {
            resolve(result)
          })
        })
      },
      getUserInfo(accessToken: string) {
        // Auth0 User Info Get method
        return new Promise((resolve, reject) => {
          this.auth0Client.client.userInfo(accessToken, (error: any, authResult: Auth0Callback<Auth0UserProfile>) => {
            if (error) {
              reject(error)
            }

            if (authResult) {
              resolve(authResult)
            }
          })
        })
      }
    },
    created() {
      // Init
      this.auth0Client = new auth0.WebAuth({
        ...options,
        redirectUri: window.location.origin + '/login'
      })
    }
  })

  return instance
}

// Create a simple Vue plugin to expose the wrapper object throughout the application
export const Auth0Plugin = {
  install(Vue: any, options: any) {
    Vue.prototype.$auth = useAuth0(options)
  }
}
